export default __webpack_public_path__ + "static/media/QnA Session to The Speaker.1be21aa8.JPG";